import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/doubleQuotes.png'


const _withScopeId = n => (_pushScopeId("data-v-16f0c45e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "brand_audio_div" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { id: "brand_audio_title" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { id: "box_bg" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "box_icon",
  src: _imports_0
}, null, -1))
const _hoisted_7 = ["v-if"]
const _hoisted_8 = {
  key: 0,
  id: "brand_audio_box_des"
}
const _hoisted_9 = {
  key: 1,
  id: "brand_audio_box_des"
}
const _hoisted_10 = {
  key: 0,
  id: "brand_audio_box_des"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BoxWithBtn = _resolveComponent("BoxWithBtn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.item.img,
      id: "brand_audio_img"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.item.title), 1),
    _createElementVNode("audio", {
      src: _ctx.item.videoURL,
      controls: "",
      id: "brand_audio_controls"
    }, null, 8, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.ps, (pdes, pi) => {
        return (_openBlock(), _createElementBlock("div", {
          "v-if": _ctx.item.ps,
          key: `box_p_${pi}`
        }, [
          (_ctx.isUnfold == true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(pdes), 1))
            : (pi < 10)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(pdes), 1))
              : _createCommentVNode("", true)
        ], 8, _hoisted_7))
      }), 128)),
      (_ctx.isUnfold == false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, "......"))
        : _createCommentVNode("", true),
      _createVNode(_component_BoxWithBtn, {
        id: "brand_audio_btn",
        text: _ctx.isUnfold ? '收起歌词' : '完整歌词',
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onUnfold(_ctx.isUnfold)))
      }, null, 8, ["text"])
    ])
  ]))
}